



















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Member } from '@/types/Member.type'
import MediaAvatar from '@/components/reusable-components/media/MediaAvatar.vue'
import { namespace } from 'vuex-class'
import RouteName from '@/utils/RouteName'
import BaseAccordion from '@/components/reusable-components/controls/BaseAccordion.vue'
import EvaIcon from '@/components/svg-components/EvaIcon.vue'
import TranslationModule from '@/utils/TranslationModule'
import { RawLocation } from 'vue-router/types/router'
import { Header } from '@/types/Header.type'
import { UserRole } from '@/types/UserRole.type'
import { Spa2Route } from '@/ExternalRoutes'
import { ArticlePublishersName } from '@/types/ressources/Ressource.type'
import APIStrapi from '@/services/ApiStrapi'
import { StrapiVideo } from '@/types/strapi/Strapi.type'

const User = namespace('user')

const BLOCK_SELECTOR = 'menu'
@Component({
    components: { EvaIcon, BaseAccordion, MediaAvatar },
})
export default class HeaderMobileMenu extends Vue {
    @Prop({ type: Boolean }) open!: boolean
    @User.State me!: Member
    @User.Getter('isAdmin') isAdmin!: boolean
    @User.Getter hasRole!: (role: UserRole) => boolean

    INVESTORS_CLUB_ID = 4
    VC_CIRCLE_ID = 15
    RouteName: typeof RouteName = RouteName
    selectedMenu: number[] | null = null
    videoList: StrapiVideo[] = []
    CLUB_BASE_URL = process.env.VUE_APP_CLUB_BASE_URL

    $refs!: {
        accordion: BaseAccordion[]
        container: HTMLElement
    }

    get config(): Header | null {
        return this.$store.state.app.headerConfiguration
    }

    get clubs(): { route: RawLocation; name: string; id: number | string; slug: string }[] | null {
        return (
            this.config &&
            this.config.clubs
                .filter(club => club.slug !== 'beta')
                .map(club => ({
                    id: club.id,
                    name: club.name,
                    route: {
                        name: RouteName.CLUB_SINGLE,
                        params: {
                            club: club.slug,
                        },
                    },
                    slug: club.slug,
                }))
        )
    }
    get investorsClub(): { route: RawLocation; name: string; id: number | string; slug: string } | null | undefined {
        return this.config && this.clubs && this.clubs.find(club => club.id === this.INVESTORS_CLUB_ID)
    }

    get vcCircleClub(): { route: RawLocation; name: string; id: number | string; slug: string } | null | undefined {
        return this.config && this.clubs && this.clubs.find(club => club.id === this.VC_CIRCLE_ID)
    }

    get hubs() {
        const regions = ['EMEA', 'APAC', 'AMERICAS']
        return (
            this.config &&
            regions.map(region => ({
                name: region,
                children:
                    this.config &&
                    this.config.hubs
                        .filter(hub => hub.region.toLowerCase() === region.toLowerCase())
                        .map(hub => ({
                            type: 'link',
                            name: hub.name.replace('Asie du Sud-Est', 'Asie SE'),
                            route: {
                                name: RouteName.HUB_SINGLE,
                                params: {
                                    hub: hub.slug,
                                },
                            },
                        })),
            }))
        )
    }

    get navigationItems() {
        if (this.hasRole('ROLE_BL_LECLUB_PARTNER_CONTACT') && !this.hasRole('ROLE_BL_LECLUB')) {
            return [
                {
                    category: this.trans('header.menu.item.account'),
                    items: [
                        {
                            label: this.trans('header.profile'),
                            url: process.env.VUE_APP_SPA2_BASE_URL + '/account',
                        },
                        {
                            label: this.trans('header.logout'),
                            url: '/logout',
                        },
                    ],
                },
            ]
        }

        const nav: Array<any> = [
            {
                category: this.trans('header.menu.item.community'),
                items: [
                    {
                        label: this.trans('header.menu.item.community.members.title'),
                        subtitle: this.trans('header.menu.item.community.members.subtitle'),
                        children: [
                            {
                                label: this.trans('header.menu.item.community.members.contacts'),
                                type: 'link',
                                route: {
                                    name: RouteName.MEMBER_LIST_CONTACTS,
                                },
                            },
                            {
                                label: this.trans('header.menu.item.community.members.favorites'),
                                type: 'link',
                                route: { name: RouteName.MEMBER_LIST_FAVORITES },
                            },
                            {
                                label: this.trans('header.menu.item.community.members.suggestions'),
                                type: 'link',
                                route: { name: RouteName.MEMBER_LIST_SUGGESTIONS },
                            },
                            {
                                label: this.trans('header.menu.item.community.members.all'),
                                type: 'footer',
                                route: {
                                    name: RouteName.MEMBER_LIST_ALL,
                                },
                            },
                            {
                                label: this.trans('header.menu.item.community.members.sponsors'),
                                type: 'footer',
                                href: `${process.env.VUE_APP_CLUB_BASE_URL}/companies`,
                            },
                        ],
                    },
                    {
                        label: this.trans('header.menu.item.community.insiders.title'),
                        subtitle: this.trans('header.menu.item.community.insiders.subtitle'),
                        children:
                            (this.clubs &&
                                this.clubs.map(club => ({
                                    label: club.name,
                                    type: 'link',
                                    route: club.route,
                                }))) ||
                            [],
                    },
                    {
                        label: this.trans('header.menu.item.community.hubs.title'),
                        subtitle: this.trans('header.menu.item.community.hubs.subtitle'),
                        categories: this.hubs,
                    },
                    {
                        label: this.trans('header.menu.item.community.members.sponsors'),
                        url: `${process.env.VUE_APP_CLUB_BASE_URL}/companies`,
                    },
                ],
            },
            {
                category: this.trans('header.menu.item.events'),
                items: [
                    {
                        label: this.trans('header.menu.item.event.meeting.title'),
                        subtitle: this.trans('header.menu.item.event.meeting.subtitle'),
                        children: [
                            {
                                label: this.trans('header.menu.item.event.meeting.physical'),
                                type: 'link',
                                route: { name: RouteName.EVENTS, query: { type: 'physical' } },
                            },
                            {
                                label: this.trans('header.menu.item.event.meeting.live'),
                                type: 'link',
                                route: { name: RouteName.EVENTS, query: { type: 'live' } },
                            },
                            {
                                label: this.trans('header.menu.item.event.meeting.all'),
                                type: 'footer',
                                route: { name: RouteName.EVENTS },
                            },
                        ],
                    },
                    {
                        label: this.trans('header.menu.item.event.city.title'),
                        subtitle: this.trans('header.menu.item.event.city.subtitle'),
                        children: [
                            {
                                label: 'New York',
                                type: 'link',
                                route: {
                                    name: RouteName.EVENTS,
                                    query: {
                                        city: 'New York',
                                    },
                                },
                            },
                            {
                                label: 'Paris',
                                type: 'link',
                                route: {
                                    name: RouteName.EVENTS,
                                    query: {
                                        city: 'Paris',
                                    },
                                },
                            },
                            {
                                label: 'Londres',
                                type: 'link',
                                route: {
                                    name: RouteName.EVENTS,
                                    query: {
                                        city: 'Londres',
                                    },
                                },
                            },
                            {
                                label: 'Madrid',
                                type: 'link',
                                route: {
                                    name: RouteName.EVENTS,
                                    query: {
                                        city: 'Madrid',
                                    },
                                },
                            },
                            {
                                label: 'Hong-Kong',
                                type: 'link',
                                route: {
                                    name: RouteName.EVENTS,
                                    query: {
                                        search: 'Hong-Kong',
                                    },
                                },
                            },
                            {
                                label: this.trans('header.menu.item.event.city.all'),
                                type: 'footer',
                                route: { name: RouteName.EVENTS },
                            },
                        ],
                    },
                ],
            },
            {
                category: this.trans('header.menu.item.resources'),
                items: [
                    {
                        label: this.trans('header.menu.item.resource.replay.title'),
                        subtitle: '',
                        children: [
                            ...((this.config &&
                                this.config.replays.map(replay => ({
                                    label: replay.title,
                                    type: 'link',
                                    route: {
                                        name: RouteName.EVENT_REPLAY,
                                        params: {
                                            eventId: replay.id,
                                            eventSlug: replay.slug,
                                        },
                                    },
                                }))) ||
                                []),
                            {
                                label: this.trans('header.menu.item.resource.replay.all'),
                                type: 'footer',
                                route: { name: RouteName.EVENTS_LIVE_AND_REPLAY },
                            },
                        ],
                    },
                    {
                        label: this.trans('header.menu.item.resource.article.title'),
                        subtitle: '',
                        children: [
                            ...((this.config &&
                                this.config.articles.map(article => ({
                                    label: article.title,
                                    type: 'link',
                                    route: {
                                        name: RouteName.ARTICLE_PAGE,
                                        params: {
                                            id: article.slug,
                                        },
                                    },
                                }))) ||
                                []),
                            {
                                label: this.trans('header.menu.item.resource.article.all'),
                                type: 'footer',
                                route: {
                                    name: RouteName.ARTICLES,
                                },
                            },
                        ],
                    },
                    {
                        label: this.trans('header.menu.item.resource.video.title'),
                        subtitle: '',
                        children: [
                            ...this.videoList.map(video => ({
                                label: video.title,
                                type: 'link',
                                href: `${this.CLUB_BASE_URL}/video/${video.slug}`,
                            })),
                            {
                                label: this.trans('header.menu.item.resource.video.all'),
                                type: 'footer',
                                href: `${this.CLUB_BASE_URL}/videos`,
                            },
                        ],
                    },
                ],
            },
            {
                category: this.trans('header.menu.item.investment'),
                items: [
                    {
                        label: this.trans('header.menu.item.investment.lefonds.title'),
                        subtitle: this.trans('header.menu.item.investment.lefonds.subtitle'),
                        children: [
                            {
                                label: this.trans('header.menu.item.investment.lefonds.more'),

                                url: 'https://www.lefonds.vc/',
                            },
                        ],
                    },
                    {
                        label: this.trans('header.menu.item.investment.investors_club.title'),
                        subtitle: this.trans('header.menu.item.investment.investors_club.subtitle'),
                        children: this.investorsClub
                            ? this.hasRole('ROLE_BL_IC')
                                ? [
                                      {
                                          label: this.trans('header.menu.item.investment.investors_club.members'),
                                          type: 'link',
                                          route: {
                                              name: RouteName.CLUB_SINGLE_MEMBERS,
                                              params: { club: this.investorsClub.slug },
                                          },
                                      },
                                      {
                                          label: this.trans('header.menu.item.investment.investors_club.deals'),
                                          type: 'link',
                                          route: {
                                              name: RouteName.CLUB_SINGLE_MARKETPLACE_PROJECTS,
                                              params: { club: this.investorsClub.slug },
                                          },
                                      },
                                      {
                                          label: this.trans('header.menu.item.investment.investors_club.videos'),
                                          type: 'link',
                                          route: {
                                              name: RouteName.CLUB_SINGLE_VIDEOS,
                                              params: { club: this.investorsClub.slug },
                                          },
                                      },
                                      {
                                          label: this.trans('header.menu.item.investment.investors_club.see'),
                                          type: 'link',
                                          route: {
                                              name: RouteName.CLUB_SINGLE,
                                              params: { club: this.investorsClub.slug },
                                          },
                                      },
                                  ]
                                : [
                                      {
                                          label: this.trans('header.menu.item.investment.investors_club.more'),
                                          type: 'footer',
                                          route: {
                                              name: RouteName.CLUB_SINGLE_JOIN,
                                              params: { club: this.investorsClub.slug },
                                          },
                                      },
                                  ]
                            : [],
                    },
                    {
                        label: this.trans('header.menu.item.investment.vc_circle.title'),
                        subtitle: this.trans('header.menu.item.investment.vc_circle.subtitle'),
                        children: this.vcCircleClub
                            ? this.hasRole('ROLE_BL_LECLUB_VC')
                                ? [
                                      {
                                          label: this.trans('header.menu.item.investment.vc_circle.videos'),
                                          type: 'link',
                                          route: {
                                              name: RouteName.CLUB_SINGLE_VIDEOS,
                                              params: { club: this.vcCircleClub.slug },
                                          },
                                      },
                                      {
                                          label: this.trans('header.menu.item.investment.vc_circle.see'),
                                          type: 'footer',
                                          route: {
                                              name: RouteName.CLUB_SINGLE,
                                              params: { club: this.vcCircleClub.slug },
                                          },
                                      },
                                  ]
                                : [
                                      {
                                          label: this.trans('header.menu.item.investment.vc_circle.more'),
                                          type: 'link',
                                          route: {
                                              name: RouteName.CLUB_SINGLE_JOIN,
                                              params: { club: this.vcCircleClub.slug },
                                          },
                                      },
                                  ]
                            : [],
                    },
                ],
            },
            {
                category: this.trans('header.menu.item.more'),
                items: [
                    {
                        label: this.trans('header.menu.item.more.workspace.title'),
                        subtitle: this.trans('header.menu.item.more.workspace.subtitle'),
                        children: [
                            {
                                label: 'New York',
                                type: 'link',
                                route: { name: RouteName.WORKSPACES, query: { location: 'New York' } },
                            },
                            {
                                label: 'Paris',
                                type: 'link',
                                route: { name: RouteName.WORKSPACES, query: { location: 'Paris' } },
                            },
                            {
                                label: 'Londres',
                                type: 'link',
                                route: { name: RouteName.WORKSPACES, query: { location: 'Londres' } },
                            },
                            {
                                label: 'Madrid',
                                type: 'link',
                                route: { name: RouteName.WORKSPACES, query: { location: 'Madrid' } },
                            },
                            {
                                label: 'Hong-Kong',
                                type: 'link',
                                route: { name: RouteName.WORKSPACES, query: { location: 'The Great Room' } },
                            },
                            {
                                label: this.trans('header.menu.item.more.workspace.all'),
                                type: 'footer',
                                route: { name: RouteName.WORKSPACES },
                            },
                        ],
                    },
                    {
                        label: this.trans('header.menu.item.more.benefit.title'),
                        subtitle: this.trans('header.menu.item.more.benefit.subtitle'),
                        children: [
                            {
                                label: 'Business',
                                type: 'link',
                                route: { name: RouteName.BENEFITS_CATEGORY, params: { category: 'business' } },
                            },
                            {
                                label: 'Hotel',
                                type: 'link',
                                route: { name: RouteName.BENEFITS_CATEGORY, params: { category: 'hotel' } },
                            },
                            {
                                label: 'Travel',
                                type: 'link',
                                route: { name: RouteName.BENEFITS_CATEGORY, params: { category: 'travel' } },
                            },
                            {
                                label: 'Lifestyle',
                                type: 'link',
                                route: { name: RouteName.BENEFITS_CATEGORY, params: { category: 'lifestyle' } },
                            },
                            {
                                label: this.trans('header.menu.item.more.benefit.all'),
                                type: 'footer',
                                route: { name: RouteName.BENEFITS },
                            },
                        ],
                    },
                    {
                        label: this.trans('header.menu.item.more.planner.title'),
                        subtitle: this.trans('header.menu.item.more.planner.subtitle'),
                        children: [
                            {
                                label: this.trans('header.menu.item.more.planner.link'),
                                type: 'link',
                                route: { name: RouteName.TRIP_PLANNER_ADD },
                            },
                            {
                                label: this.trans('header.menu.item.more.plannerlist.link'),
                                type: 'link',
                                route: { name: RouteName.TRIP_PLANNER_LIST },
                            },
                        ],
                    },
                ],
            },
        ]

        const accountNav: {
            category: string
            items: { label: string; url?: string; route?: RawLocation; click?: () => unknown }[]
        } = {
            category: this.trans('header.menu.item.account'),
            items: [],
        }

        if (window.__isJwtSwitch) {
            accountNav.items.push({
                label: this.trans('header.back.admin'),
                url: process.env.VUE_APP_SPA2_BASE_URL + '/exit-switch-to',
            })
        }

        if (this.isAdmin) {
            accountNav.items.push({
                label: this.trans('header.admin.dashboard'),
                url: process.env.VUE_APP_ADMIN_BASE_URL + '/dashboard',
            })
        }

        accountNav.items.push({
            label: this.trans('header.connections'),
            url: process.env.VUE_APP_SPA2_BASE_URL + '/member',
        })

        if (this.me && this.me.prospect_admin) {
            accountNav.items.push({
                label: this.trans('header.menu.my_relationship_manager'),
                url: Spa2Route.INBOX_NEW(this.me.prospect_admin.idff),
                click: () => {
                    window.analytics.track('leclub:rm')
                },
            })
        }

        accountNav.items.push({
            label: 'Mes NFTs',
            route: { name: RouteName.NFT_HOME },
        })

        accountNav.items.push(
            {
                label: this.trans('header.profile'),
                route: { name: RouteName.MEMBER_ME },
            },
            {
                label: this.trans('header.ids'),
                url: process.env.VUE_APP_SPA2_BASE_URL + '/account/security',
            },
            {
                label: this.trans('header.membership'),
                url: '/member/me/membership',
            },
            {
                label: this.trans('header.icon.refer'),
                route: { name: RouteName.MEMBER_RECOMMEND },
            },
            {
                label: this.trans('header.logout'),
                route: { name: RouteName.LOGOUT },
            }
        )

        nav.push(accountNav)

        return nav
    }

    get classList() {
        return [
            BLOCK_SELECTOR,
            {
                [`${BLOCK_SELECTOR}--open`]: this.open,
                [`${BLOCK_SELECTOR}--leveled`]: this.selectedMenu !== null,
            },
        ]
    }

    get selectedMenuItems() {
        if (this.selectedMenu !== null) {
            const [category, item] = this.selectedMenu

            const selectedCategory = this.navigationItems[category]

            if (selectedCategory) {
                return selectedCategory.items && selectedCategory.items[item]
            }
        }

        return null
    }

    async created() {
        this.videoList = await APIStrapi.getVideoList({ limit: 3, publisher: ArticlePublishersName.CLUB })
    }

    trans(key: string) {
        return this.$trans(key, TranslationModule.COMMON)
    }

    close() {
        this.$emit('close')
        this.selectedMenu = null
        this.$refs.accordion.forEach(acc => {
            acc.open = false
        })
    }

    selectMenu(category: number, item: number) {
        this.selectedMenu = [category, item]
        this.$refs.container.scrollTo(0, 0)
    }

    onClickItem(
        item: { children?: any; categories?: any; click?: () => unknown },
        itemIndex: number,
        categoryIndex: number
    ) {
        if (item.children || item.categories) {
            return this.selectMenu(categoryIndex, itemIndex)
        } else if (item.click) {
            return item.click()
        } else {
            return false
        }
    }
}
